/* =========================================================
   HOODVILLE — site.js (vanilla, no framework)
   Drawers + accessible focus trap, and the REAL Shopify cart
   (Cart AJAX API: /cart/add.js, /cart/change.js, /cart.js).
   The PDP form submits natively to Shopify; this file upgrades
   that to an AJAX add with a drawer, and falls back to a native
   submit if the fetch ever fails.
   ========================================================= */
(function(){
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  // ---------- DRAWERS (accessible modal: focus move + trap + restore) ----------
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let drawerOpener = null;
  function openDrawer(d){
    if (!d) return;
    drawerOpener = document.activeElement;
    d.classList.add('is-open');
    d.removeAttribute('inert');
    d.setAttribute('aria-modal','true');
    document.body.style.overflow='hidden';
    const focus = d.querySelector('input[type="search"]') || d.querySelector('[data-drawer-close]');
    if (focus) focus.focus();
  }
  function closeDrawer(d){
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('inert','');
    d.removeAttribute('aria-modal');
    if (!$$('.drawer.is-open').length) document.body.style.overflow='';
    if (drawerOpener && drawerOpener.focus){ drawerOpener.focus(); drawerOpener = null; }
  }
  document.addEventListener('click', (e)=>{
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { openDrawer($(opener.getAttribute('data-drawer-open'))); }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); }
    if (e.target.matches('.drawer__scrim')) { closeDrawer(e.target.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); return; }
    if (e.key !== 'Tab') return;
    const d = document.querySelector('.drawer.is-open');
    if (!d) return;
    const items = $$(FOCUSABLE, d).filter(el => el.offsetWidth || el.offsetHeight || el === document.activeElement);
    if (!items.length) return;
    const first = items[0], last = items[items.length-1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  // ---------- MONEY (Shopify standard, driven by shop money_format) ----------
  function formatMoney(cents){
    const format = (window.HV && window.HV.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal){
      precision = (precision == null) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number/100).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cts = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cts;
    }
    let value = '';
    const match = format.match(placeholder);
    switch (match ? match[1] : 'amount'){
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  // ---------- CART (Shopify Cart AJAX API) ----------
  const CART_ADD = '/cart/add.js';
  const CART_CHANGE = '/cart/change.js';
  const CART_GET = '/cart.js';
  // MEM discount tiers in cents — a "spend more to unlock the code" nudge only.
  // Codes are applied by Shopify at checkout; we never compute a discounted total here.
  const MEM_TIERS = [ {min:10000, pct:20, code:'MEM20'}, {min:15000, pct:25, code:'MEM25'}, {min:20000, pct:30, code:'MEM30'} ];
  let lastCount = null;

  function imgAt(url, w){
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function lineHTML(item){
    const variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? `<div class="cart-line__variant">${item.variant_title}</div>` : '';
    const img = item.image ? `<img src="${imgAt(item.image,160)}" alt="" width="80" height="100" loading="lazy">` : '';
    return `<div class="cart-line" data-key="${item.key}">
      <div class="cart-line__media">${img}</div>
      <div>
        <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
        ${variant}
        <div class="cart-line__qty"><div class="qty">
          <button type="button" data-qty-dec aria-label="Decrease">−</button>
          <input type="text" inputmode="numeric" aria-label="Quantity" value="${item.quantity}" data-qty-input>
          <button type="button" data-qty-inc aria-label="Increase">+</button>
        </div></div>
        <button type="button" class="cart-line__remove" data-line-remove>Remove</button>
      </div>
      <div class="cart-line__price">${formatMoney(item.final_line_price)}</div>
    </div>`;
  }
  function renderCart(cart){
    if (!cart) return;
    const count = cart.item_count || 0;
    $$('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = (el.classList.contains('iconbtn__badge') && count === 0) ? 'none' : '';
    });
    if (lastCount !== null && count > lastCount){
      $$('[data-cart-count]').forEach(el => { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
    }
    lastCount = count;

    const list = $('#cart-lines');
    if (list){
      list.innerHTML = (cart.items && cart.items.length)
        ? cart.items.map(lineHTML).join('')
        : `<p class="muted" style="padding:32px 0;text-align:center;font-family:var(--ff-mono);font-size:12px;letter-spacing:.16em;text-transform:uppercase">Bag is empty</p>`;
    }
    $$('[data-cart-total]').forEach(el => { el.textContent = formatMoney(cart.total_price || 0); });

    // discount-tier nudge (drawer)
    $$('[data-shipbar]').forEach(bar => {
      const t = cart.total_price || 0;
      const next = MEM_TIERS.find(tier => t < tier.min);
      const fill = bar.querySelector('.shipbar__fill');
      const msg = bar.querySelector('[data-shipbar-msg]');
      const cap = bar.querySelector('[data-shipbar-cap]') || bar.querySelector('.shipbar__top span:last-child');
      if (next){
        if (fill) fill.style.width = Math.min(100, (t/next.min)*100) + '%';
        if (msg) msg.innerHTML = `Add <b>${formatMoney(next.min - t)}</b> for ${next.pct}% off · code ${next.code}`;
        if (cap) cap.textContent = formatMoney(next.min);
      } else {
        if (fill) fill.style.width = '100%';
        if (msg) msg.innerHTML = `<b>30% off unlocked</b> · code MEM30`;
        if (cap) cap.textContent = formatMoney(20000);
      }
    });
  }
  function getCart(){
    return fetch(CART_GET, { headers:{ 'Accept':'application/json' } }).then(r => r.json());
  }
  function changeLine(key, qty){
    return fetch(CART_CHANGE, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(r => r.json()).then(cart => { renderCart(cart); return cart; });
  }

  // ---------- ADD TO CART: intercept the product form, AJAX it, open the bag ----------
  function addForm(form){
    const btn = form.querySelector('[data-add-btn]') || form.querySelector('button[name="add"]');
    if (btn) btn.setAttribute('disabled','');
    fetch(CART_ADD, { method:'POST', headers:{ 'Accept':'application/json' }, body: new FormData(form) })
      .then(r => r.json().then(data => ({ ok:r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok){
          // e.g. sold out / inventory error — let Shopify show it via a native submit
          if (btn) btn.removeAttribute('disabled');
          form.submit();
          return;
        }
        return getCart().then(cart => {
          renderCart(cart);
          if (btn) btn.removeAttribute('disabled');
          if (isPhone()){ flyToBag($('.pdp__main img')); }
          else { openDrawer($('#drawer-cart')); }
        });
      })
      .catch(() => { if (btn) btn.removeAttribute('disabled'); form.submit(); });
  }
  document.addEventListener('submit', (e)=>{
    const form = e.target.closest('.pdp__info, form[action$="/cart/add"]');
    if (!form) return;
    if (e.defaultPrevented) return;   // PDP inline validation (e.g. size required) already blocked it
    e.preventDefault();
    addForm(form);
  });

  // ---------- CART LINE controls (drawer) ----------
  document.addEventListener('click', (e)=>{
    const rm = e.target.closest('.cart-line [data-line-remove]');
    if (rm){ const line = rm.closest('.cart-line'); if (line){ e.preventDefault(); changeLine(line.dataset.key, 0); } return; }
    const inc = e.target.closest('.cart-line [data-qty-inc]');
    if (inc){ const line = inc.closest('.cart-line'); const ip = line.querySelector('[data-qty-input]'); changeLine(line.dataset.key, (parseInt(ip.value,10)||1)+1); return; }
    const dec = e.target.closest('.cart-line [data-qty-dec]');
    if (dec){ const line = dec.closest('.cart-line'); const ip = line.querySelector('[data-qty-input]'); changeLine(line.dataset.key, Math.max(0,(parseInt(ip.value,10)||1)-1)); return; }
  });
  document.addEventListener('change', (e)=>{
    const qi = e.target.closest('.cart-line [data-qty-input]');
    if (qi){ const line = qi.closest('.cart-line'); changeLine(line.dataset.key, Math.max(0, parseInt(qi.value,10)||0)); }
  });

  // ---------- MOBILE DELIGHT: fly-to-bag ----------
  const isPhone = () => window.matchMedia('(max-width:760px)').matches;
  const noMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function flyToBag(sourceEl){
    if (!isPhone() || noMotion()) return;
    const cartBtn = document.querySelector('[data-drawer-open="#drawer-cart"]');
    const img = sourceEl && (sourceEl.tagName === 'IMG' ? sourceEl : sourceEl.querySelector('img'));
    if (!cartBtn || !img) return;
    const s = img.getBoundingClientRect(), t = cartBtn.getBoundingClientRect();
    if (!s.width || !t.width) return;
    const clone = img.cloneNode(true);
    Object.assign(clone.style, {
      position:'fixed', left:s.left+'px', top:s.top+'px', width:s.width+'px', height:s.height+'px',
      objectFit:'contain', margin:'0', zIndex:'2000', pointerEvents:'none', borderRadius:'2px',
      transition:'transform 600ms cubic-bezier(.5,0,.3,1), opacity 600ms ease', willChange:'transform,opacity'
    });
    document.body.appendChild(clone);
    const dx = (t.left + t.width/2) - (s.left + s.width/2);
    const dy = (t.top + t.height/2) - (s.top + s.height/2);
    requestAnimationFrame(() => { clone.style.transform = `translate(${dx}px, ${dy}px) scale(.08) rotate(-6deg)`; clone.style.opacity = '.25'; });
    setTimeout(() => {
      clone.remove();
      $$('[data-cart-count]').forEach(el => { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
      if (navigator.vibrate) navigator.vibrate(12);
    }, 600);
  }

  // ---------- QUICK ADD on product cards (size-aware, real cart) ----------
  // One tap on a card goes to the product page; the quick-add button adds to the
  // bag without leaving the grid (picking a size first for apparel).
  function qaAdd(id, btn){
    if (btn) btn.setAttribute('disabled','');
    fetch(CART_ADD, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items:[{ id: Number(id), quantity: 1 }] }) })
      .then(function(r){ return r.json().then(function(d){ return { ok:r.ok, d:d }; }); })
      .then(function(res){
        if (btn) btn.removeAttribute('disabled');
        if (!res.ok) return;
        var src = btn && btn.closest('.pcard__media') ? btn.closest('.pcard__media').querySelector('img') : null;
        getCart().then(function(cart){ renderCart(cart); if (isPhone()){ flyToBag(src); } else { openDrawer($('#drawer-cart')); } });
      })
      .catch(function(){ if (btn) btn.removeAttribute('disabled'); });
  }
  function qaClose(){ $$('.qa-pop').forEach(function(p){ p.remove(); }); }
  function qaOpenSizes(wrap, variants, btn){
    qaClose();
    var pop = document.createElement('div');
    pop.className = 'qa-pop';
    pop.innerHTML = '<div class="qa-pop__t">Select size</div><div class="qa-pop__g">' +
      variants.map(function(v){ return '<button type="button" data-qa-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + v.title + '</button>'; }).join('') + '</div>';
    Object.assign(pop.style, { position:'absolute', left:'8px', right:'8px', bottom:'56px', background:'var(--hv-bone)', border:'1px solid var(--hv-line-strong)', padding:'12px', zIndex:'6', borderRadius:'2px', boxShadow:'0 6px 20px rgba(10,9,8,.18)' });
    pop.querySelector('.qa-pop__t').style.cssText = 'font-family:var(--ff-mono);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--hv-smoke);margin-bottom:8px';
    pop.querySelector('.qa-pop__g').style.cssText = 'display:grid;grid-template-columns:repeat(3,1fr);gap:4px';
    pop.querySelectorAll('button').forEach(function(b){
      b.style.cssText = 'padding:0;min-height:40px;border:1px solid var(--hv-line-strong);background:transparent;font-family:var(--ff-mono);font-size:11px;cursor:pointer;border-radius:2px';
      b.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); if (b.disabled) return; qaAdd(b.getAttribute('data-qa-vid'), btn); qaClose(); });
    });
    pop.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); });
    var media = wrap.closest('.pcard__media') || wrap;
    media.appendChild(pop);
    setTimeout(function(){ document.addEventListener('click', function out(ev){ if (!ev.target.closest('.qa-pop') && !ev.target.closest('[data-quick-add]')){ qaClose(); } else { document.addEventListener('click', out, { once:true }); } }, { once:true }); }, 0);
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();           // never navigate to the PDP from the quick-add button
    var wrap = btn.closest('[data-card-quick]'); if (!wrap) return;
    var variants = []; try { variants = JSON.parse(wrap.dataset.variants || '[]'); } catch(err){}
    if (wrap.dataset.default === 'true' || variants.length <= 1){
      var vid = wrap.dataset.vid || (variants[0] && variants[0].id);
      if (vid) qaAdd(vid, btn);
    } else {
      qaOpenSizes(wrap, variants, btn);
    }
  });

  // ---------- STICKY "SHOP THE DROP" BAR (home) ----------
  const shopBar = $('.shop-bar');
  if (shopBar){
    const hero = $('.hero');
    let footer = document.querySelector('.site-footer');
    const syncShopBar = () => {
      if (!footer) footer = document.querySelector('.site-footer');   // footer may be rendered/injected after this script runs
      const pastHero = hero ? (hero.getBoundingClientRect().bottom < 0) : (window.scrollY > 360);
      // hide once the footer is in view so the bar never covers the bottom of the page
      const footerNear = footer ? (footer.getBoundingClientRect().top < window.innerHeight + 20) : false;
      const show = pastHero && !footerNear;
      shopBar.classList.toggle('is-show', show);
      document.body.classList.toggle('shopbar-on', show);   // lifts the a11y launcher above the bar on mobile
    };
    // coalesce to one layout read per frame so fast flings on a phone don't thrash layout
    let barTicking = false;
    const onBarScroll = () => {
      if (barTicking) return;
      barTicking = true;
      requestAnimationFrame(() => { syncShopBar(); barTicking = false; });
    };
    window.addEventListener('scroll', onBarScroll, { passive:true });
    window.addEventListener('resize', onBarScroll, { passive:true });
    syncShopBar();
  }

  // ---------- SCROLL REVEAL (home/PLP content rises in as it enters view) ----------
  // IntersectionObserver instead of a per-scroll getBoundingClientRect loop: the browser
  // computes intersections off the main thread, so the first fling on a phone never pays
  // for synchronous layout reads while the LCP image is still decoding.
  if (document.documentElement.classList.contains('js')){
    const revealEls = $$('.manifesto__text, .section__head, .cats .cat, .card-grid .pcard');
    if (revealEls.length){
      $$('.cats .cat').forEach((el,i) => el.style.setProperty('--reveal-i', i));
      $$('.card-grid').forEach(grid =>
        grid.querySelectorAll('.pcard').forEach((el,i) => el.style.setProperty('--reveal-i', i % 8)));
      if ('IntersectionObserver' in window){
        const io = new IntersectionObserver((entries) => {
          entries.forEach(en => { if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
        }, { rootMargin: '0px 0px -10% 0px' });
        setTimeout(function(){ revealEls.forEach(function(el){ var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0){ el.classList.add('is-in'); } }); }, 200);
        revealEls.forEach(el => io.observe(el));
      } else {
        revealEls.forEach(el => el.classList.add('is-in'));
      }
    }
  }

  // ---------- INITIAL SYNC (populate badge/total/shipbar from the real cart) ----------
  // badge/total/lines are already server-rendered; defer this below first paint so it never competes with the LCP
  (window.requestIdleCallback || function(cb){ return setTimeout(cb, 1); })(function(){ getCart().then(renderCart).catch(function(){}); });

  // ---------- ACCESSIBILITY PANEL ("read better") — native, opt-in ----------
  (function(){
    var KEY = 'hv-a11y';
    var root = document.documentElement;
    function read(){ try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch(e){ return {}; } }
    function write(s){ try { localStorage.setItem(KEY, JSON.stringify(s)); } catch(e){} }
    function apply(s){
      root.classList.remove('hv-a11y-text-1','hv-a11y-text-2');
      if (s.text) root.classList.add('hv-a11y-text-' + s.text);
      root.classList.toggle('hv-a11y-contrast', !!s.contrast);
      root.classList.toggle('hv-a11y-font', !!s.font);
      root.classList.toggle('hv-a11y-underline', !!s.underline);
      root.classList.toggle('hv-a11y-motion', !!s.motion);
    }
    // Reflect saved state in the panel UI. Safe to call before the panel exists; it
    // just no-ops until the controls are present (also re-run when the panel opens).
    function refresh(){
      var s = read();
      $$('[data-a11y-text]').forEach(function(b){ b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-a11y-text')) === (s.text || 0))); });
      $$('[data-a11y-toggle]').forEach(function(b){ b.setAttribute('aria-pressed', String(!!s[b.getAttribute('data-a11y-toggle')])); });
      if ('speechSynthesis' in window){ var g = $('[data-a11y-speech]'); if (g) g.hidden = false; }
    }
    var reading = false;
    function stopRead(){ if (window.speechSynthesis) window.speechSynthesis.cancel(); reading = false; var b = $('[data-a11y-read]'); if (b) b.textContent = 'Read this page'; }

    apply(read()); refresh();

    document.addEventListener('click', function(e){
      if (e.target.closest('[data-drawer-open="#drawer-a11y"]')){ refresh(); }   // re-sync the controls when the panel opens
      var seg = e.target.closest('[data-a11y-text]');
      if (seg){ var s1 = read(); s1.text = Number(seg.getAttribute('data-a11y-text')); write(s1); apply(s1); refresh(); return; }
      var tog = e.target.closest('[data-a11y-toggle]');
      if (tog){ var k = tog.getAttribute('data-a11y-toggle'); var s2 = read(); s2[k] = !s2[k]; write(s2); apply(s2); refresh(); return; }
      if (e.target.closest('[data-a11y-reset]')){ write({}); apply({}); refresh(); stopRead(); return; }
      var rd = e.target.closest('[data-a11y-read]');
      if (rd && ('speechSynthesis' in window)){
        if (reading){ stopRead(); return; }
        var main = document.getElementById('MainContent') || document.body;
        var text = (main.innerText || main.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 6000);
        if (!text) return;
        var u = new SpeechSynthesisUtterance(text);
        u.rate = 0.85;   // slower than the browser default — clearer, less rushed
        u.lang = document.documentElement.lang || 'en-US';
        u.onend = stopRead; u.onerror = stopRead;
        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(u);
        reading = true; rd.textContent = 'Stop reading';
      }
    });
    window.addEventListener('pagehide', stopRead);
  })();

  // Expose a small surface for the feed/debugging
  window.HV = window.HV || {};
  Object.assign(window.HV, { getCart, changeLine, renderCart, formatMoney, openDrawer });
})();
